import ButtonComp from "themes/elements/Button";
import { isPermit } from "utils/permissionCheck";

function NonApprovalButtons(props) {
  const { onEdit, setDlt, selectedNews, tabActive } = props;

  const showEditButton =
    tabActive === "5" ||
    (tabActive === "4" && selectedNews.allow_resubmission_flg);

  return (
    <>
      {isPermit(3, "delete") && (
        <ButtonComp variant="secondary" onClick={() => setDlt(true)}>
          Delete
        </ButtonComp>
      )}
      {showEditButton && isPermit(3, "edit") && (
        <ButtonComp onClick={() => onEdit(selectedNews)}>Edit</ButtonComp>
      )}
    </>
  );
}

export default NonApprovalButtons;
